<template>
  <div>
    <v-container v-if="!mini"
      id="userProfileSelect"
      class="fill-height justify-center"
      tag="section"
    >
      <v-card id="accountSelection" width="400">
        <v-card-title class="text-center">
{{ $t('login.select-a-profile') }}
</v-card-title>
        <v-card-text>
          {{ $t('login.profile-user-associated') }}
</v-card-text>
        <v-card-text>
        <div v-if="loading">
          Loading
        </div>
        <div v-else>
          <v-list>
          <v-list-item v-for="[key, profile] of Object.entries(profiles)" :key="key" class="pa-0">
            <v-btn :text="mini" color="secondary" block :disabled="isActiveProfile(key)" @click="setProfile(key)">
              {{ profile.account.displayName }}
            </v-btn>
          </v-list-item>
          <v-list-item class="pa-0">
            <v-btn :text="mini" color="blue" block @click="editProfileDialog">
{{ $t('global.profile') }}
</v-btn>
          </v-list-item>
          <hr>
          <v-list-item class="pa-0">
            <v-btn :text="mini" color="primary" block @click="logout">
              {{ $t('global.logout') }}
            </v-btn>
          </v-list-item>
        </v-list>
        </div>
        </v-card-text>
      </v-card>
    </v-container>
    <div v-if="mini">
      <div v-if="loading">
        Loading
      </div>
      <div v-else>
        <v-list>
          <v-list-item class="pa-0">
            <v-btn :text="mini" color="blue" block @click="editProfileDialog">
              {{ $t('global.profile') }}
            </v-btn>
          </v-list-item>
          <div v-show="Object.entries(profiles).length>1">
            <hr>
            <v-list-item v-for="[key, profile] of Object.entries(profiles)" :key="key" class="pa-0 account">
              <v-btn :text="mini" color="secondary" block :disabled="isActiveProfile(key)" @click="setProfile(key)">
                {{ profile.account.displayName }}
              </v-btn>
            </v-list-item>
            <hr>
          </div>
          <v-list-item class="pa-0">
            <v-btn :text="mini" color="primary" block @click="logout">
              {{ $t('global.logout') }}
            </v-btn>
          </v-list-item>
        </v-list>
      </div>
    </div>
  </div>
</template>

<script>
  import firebase from 'firebase/app'
  import 'firebase/auth'
  import router from '@/router'
  // import api from '@/helpers/api.js'
  import { Roles, filterSoftDeleteAccounts } from '@/helpers/users.js'
  import { cookies } from '@/util/cookies'

  export default {
    name: 'UserProfileSelection',

    props: {
      mini: {
        type: Boolean,
        default: false,
      },
    },

    data: function () {
      return {
        error: '',
        loading: true,
        profiles: undefined,
      }
    },

    async mounted () {
      this.loading = true
      const userAuthID = firebase.auth().currentUser.uid
      // console.log(' current auth user = ' + userAuthID)
      await this.$store.dispatch('fetchUserProfiles', userAuthID)
      this.profiles = filterSoftDeleteAccounts(this.$store.getters.userProfiles)
      // console.log('Profiles = ' + JSON.stringify(Object.entries(this.profiles)))
      this.loading = false
    },

    methods: {
      async setProfile (userid) {
        const currentUserProfile = this.$store.getters.userProfiles[userid]
        // console.log('currentUserProfile = ' + currentUserProfile + ' key ' + userid)
        // profile.account = profile.account
        this.$store.commit('SET_CURRENT_USER_PROFILE', currentUserProfile)
        cookies.set('currentUserID', userid)

        const originalUrl = cookies.get('toPath')

        // Set language
        this.$i18n.locale = currentUserProfile.account.locale ?? 'en'

        if (originalUrl !== null) {
          cookies.remove('toPath')
          router.push({ path: originalUrl })
        } else if (currentUserProfile.user.roles.includes(Roles.SUPER) ||
          currentUserProfile.user.roles.includes(Roles.SUPERADMIN))
        {
          router.push({ path: '/admin/accounts' })
        } else if (currentUserProfile.user.roles.includes(Roles.ADMIN)) {
          router.push({ path: '/admin/dashboard' })
        } else {
          router.push({ path: '/admin/learner' })
        }
      },
      editProfileDialog () {
        router.push({ path: '/editProfile' })
      },

      async logout () {
        // Clear vars
        this.$store.dispatch('logoutUser')
        await firebase.auth().signOut()
        router.push('/login')
      },

      isActiveProfile (userid) {
        if (!this.mini)
        {
          return false
        }
        return userid === this.$store.getters.currentUserProfile.user.id
      },
    },
  }
</script>

<style scoped>
.small {
  width: 100%;
  text-align: center;
  font-size: 10px;
  line-height: 10px;
  padding-top: 5px;
  margin: 0;
}

.passworderror {
  background: transparent;
  color: red;
  font-weight: bold;
}

.clean {
  background: none !important;
}

.account {
  color: blue;
}

.account .small {
  font-size: 10px;
}

</style>
